import { Component, OnInit } from '@angular/core';

import { FuseConfigService } from '@fuse/services/config';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        private _fuseConfigService: FuseConfigService
    ) { }

    ngOnInit(): void {
        // Check if the user is a client
        if (localStorage.getItem('user-type') === 'client') {
            this._fuseConfigService.config = { layout: 'material' };
        } else {
            this._fuseConfigService.config = { layout: 'enterprise' };
        }
    }
}